
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/pasm-okr",
      function () {
        return require("private-next-pages/solutions/pasm-okr/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/pasm-okr"])
      });
    }
  